import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, Row, UiBox, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {PAGE_URLS} from '~/constants';
import {PRODUCT_SKUS, WEIGHT_LOSS_KEYS, WEIGHT_LOSS_ONE_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import novofinePlus from '~/assets/images/novofineplus.png';
import PhaseDescribe from '~/components/shared/PhaseDescribe';

interface Props {}

const Questionnaire11NextPanbesyScreen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.WHATS_NEXT_PANBESY);

  const collectedData = mdq.collectedData;

  const selectedPackage = collectedData[WEIGHT_LOSS_KEYS.PACKAGE_SELECTION] || {};
  const selectedProducts = selectedPackage?.data?.productSkus || [];

  const onClickSubmit = () => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.WHATS_NEXT_PANBESY,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));

    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_KEYS.WHATS_NEXT_PANBESY]: answerData,
          },
        },
      }),
    );
    // dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.APPOINTMENT_PREFERENCES}));
    history.push(PAGE_URLS.MDQ1_APPOINTMENT_PREFERENCES);
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      handleOnNext={onClickSubmit}
      pageTitle={questionnaire?.title}
    >
      <Col alignItems="center" textAlign="center" mt={12} px={1}>
        <UiText fontSize="xl" fontWeight="bold" mb={4}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiText fontSize="sm" fontWeight="400" mb={4}>
          {questionnaire?.questions?.sub}
        </UiText>
        <Col>
          {questionnaire?.phasesDescriptions?.map((phaseDescription, index) => (
            <PhaseDescribe key={index} phaseDescription={phaseDescription} />
          ))}
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire11NextPanbesyScreen;
